<template>
  <div class="displayflex flexbetween marginbottom15">
    <div :class="['fontsize18', headerClasses ? headerClasses : '']">{{name}}</div>
    <div class="selfAlignCenter" @click="closeSidebar">
      <SVGIcon name="close" size="small" class="cursor-pointer"/>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: ["name", "headerClasses"],
  methods: {
    closeSidebar() {
      this.$store.commit("setExtendedSidebarActiveFalse");
    }
  }
};
</script>

<style scoped>

</style>
